import styled from 'styled-components'
import PropTypes from 'prop-types'

import { SLR } from '@h2/components/colors'
import { Text } from '@h2/components/typography/text'

const Dot = styled.span`
  position: absolute;
  left: 50%;
  top: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  height: 14px;
  border: 1px solid ${SLR};
  border-radius: 50%;
  background-color: ${SLR};
`
const Notification = ({ count }) => {
  return (
    <Dot>
      <Text as="span" color="white" size="small" weight="bold">
        {count}
      </Text>
    </Dot>
  )
}

Notification.propTypes = {
  count: PropTypes.number.isRequired
}

export { Notification }
